import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Icons } from '@hmsexp/component-library';

const BreadcrumbHeader = ({ onGoBack, backText }) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={onGoBack} style={styles.backBtn}>
        <Icons.ChevronLeft width={20} height={20} color='#4050c6' />

        <View style={styles.textWrapper}>
          <Text style={styles.backText}>{backText}</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default BreadcrumbHeader;

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: 1,
    borderColor: '#eee',
    paddingVertical: 6,
    paddingHorizontal: 10,
    backgroundColor: '#f9f9f9'
  },

  backBtn: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'nowrap'
  },

  textWrapper: {
    flexShrink: 1,
    paddingLeft: 6
  },

  backText: {
    color: '#1b2438',
    fontSize: 16,
    fontWeight: '600',
    flexWrap: 'wrap'
  }
});
